//import http from "@/common/http-common";
//import store from "@/store";

class GeoLocationService {
  getPosition(options) {
    return new Promise((resolve, reject) => 
        navigator.geolocation.getCurrentPosition(resolve, reject, options)
    );
  }
}

export default new GeoLocationService();